import { useState, useEffect } from "react";
import "./Modal.scss"; // 对应样式文件

/**
 * 通用弹窗组件
 * @param {boolean} visible - 控制弹窗显示/隐藏
 * @param {Function} onClose - 关闭弹窗的回调函数
 * @param {string|ReactNode} title - 弹窗标题（默认："弹窗标题"）
 * @param {string|ReactNode} content - 弹窗内容（支持字符串/HTML/React节点）
 * @param {boolean} closeOnMaskClick - 是否允许点击遮罩关闭（默认：true）
 * @param {boolean} showCloseBtn - 是否显示关闭按钮（默认：true）
 */
const Modal = ({
  visible,
  onClose,
  title = "弹窗标题",
  content,
  closeOnMaskClick = true,
  showCloseBtn = true,
}) => {
  // 点击遮罩层关闭弹窗
  const handleMaskClick = (e) => {
    if (closeOnMaskClick && e.target.classList.contains("modal-mask")) {
      onClose?.();
    }
  };

  // 按ESC键关闭弹窗
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && visible) {
        onClose?.();
      }
    };
    window.addEventListener("keydown", handleEsc);
    // 组件卸载/visible变化时移除监听
    return () => window.removeEventListener("keydown", handleEsc);
  }, [visible, onClose]);

  // 弹窗隐藏时不渲染任何内容
  if (!visible) return null;

  return (
    <div className='modal-mask' onClick={handleMaskClick}>
      <div className='modal-container'>
        {/* 关闭按钮（可配置是否显示） */}
        {showCloseBtn && (
          <button className='modal-close' onClick={onClose}>
            ×
          </button>
        )}

        {/* 弹窗标题（内容存在时显示，避免空标题占位） */}
        {title && <h2 className='modal-title'>{title}</h2>}

        {/* 弹窗内容区域（支持多种内容类型） */}
        <div className='modal-content'>
          {typeof content === "string" ? (
            // 字符串内容支持HTML渲染（需谨慎使用，避免XSS）
            <div dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            // 非字符串直接渲染React节点
            content
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
